/**
 * Adobe Analytics event strings matching the ETM WAVE Data Layer Tech Spec.
 * Each string corresponds to an Adobe event (e.g., processStart -> e119).
 */
export const AdobeAnalyticsEvent = {
  PAGE_LOADED: "pageLoaded",
  USER_DETECTED: "userDetected",
  PAGE_LOAD_COMPLETED: "pageLoadCompleted",
  CALL_TO_ACTION: "callToAction",
  PROCESS_START: "processStart",
  PROCESS_STEP_SUCCESS: "processStepSuccess",
  PROCESS_COMPLETE: "processComplete",
  PROCESS_ABANDONED: "processAbandoned",
  PROCESS_ERROR: "processError",
  SUB_PAGE_VIEWED: "subPageViewed",
} as const;

export type AdobeAnalyticsEventType =
  (typeof AdobeAnalyticsEvent)[keyof typeof AdobeAnalyticsEvent];
